import { APP_NAME } from "@grundbesitz/shared";
import { inviteLink, navigate } from "../../lib/router";
import { useStore } from "../../lib/store";
import { Button } from "../ui/Button";
import { CodeTiles } from "./CodeTiles";
import { canShare, copyText } from "./clipboard";

/** Room code, invite link actions and the way out of the room. */
export function RoomHeader({ code }: { code: string }) {
  const toast = useStore((s) => s.toast);
  const link = inviteLink(code);

  const copy = async () => {
    if (await copyText(link)) toast("Einladungslink kopiert.", "success");
    else toast(`Kopieren nicht möglich. Der Link lautet ${link}`, "error");
  };

  const share = async () => {
    try {
      await navigator.share({ title: APP_NAME, text: `Komm ins Spiel. Raum-Code ${code}.`, url: link });
    } catch (err) {
      if (!(err instanceof DOMException && err.name === "AbortError")) toast("Teilen ist fehlgeschlagen.", "error");
    }
  };

  return (
    <section aria-labelledby="room-title" className="flex flex-wrap items-end justify-between gap-x-8 gap-y-4 pt-6 pb-8">
      <div>
        <h1 id="room-title" className="mb-3 font-display text-xl font-semibold text-ink">
          Raum-Code
        </h1>
        <CodeTiles code={code} />
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Button onClick={() => void copy()}>Einladungslink kopieren</Button>
        {canShare() && <Button onClick={() => void share()}>Teilen</Button>}
        <Button variant="ghost" onClick={() => navigate("/")}>
          Raum verlassen
        </Button>
      </div>
    </section>
  );
}
